import { Injectable } from '@angular/core';
import { LotDetailContext } from './lot-detail.context';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';

@Injectable({ providedIn: 'root' })
export class LotDetailPopupService {

    private modal: Modal | null = null;

    constructor(private lotDetailContext: LotDetailContext,
                private router: Router) { }

    openLotDetail(lotUUID: string, initialTab: 'lot-basic-details' | 'source' | 'attributes' | 'files' = 'lot-basic-details') {
        // Navigate to the modal route with initial tab
        this.router.navigate([{
            outlets: {
                'lotDetailPopup': ['lot-detail-main', lotUUID, { initialTab: initialTab }],
            }
        }], { onSameUrlNavigation: 'reload', queryParamsHandling: 'preserve' }).then(() => {
            // Initialize and show Bootstrap modal
            const modalElement = document.getElementById('lotDetailModal');
            if (modalElement) {
                // Set z-index before initializing the modal
                modalElement.style.zIndex = '10100'; // or any other value you need
                const backdropElement = document.querySelector('.modal-backdrop');
                if (backdropElement) {
                    (backdropElement as HTMLElement).style.zIndex = '10000';
                }

                this.modal = new Modal(modalElement, {
                    keyboard: true,
                    backdrop: 'static',  // Prevent closing by clicking outside
                });
                this.modal.show();

                // Handle modal closing
                modalElement.addEventListener('hidden.bs.modal', () => {
                    this.router.navigate([{ outlets: { 'lotDetailPopup': null, 'lot-detail-outlet': null } }], { queryParamsHandling: 'preserve' });
                    // Reset the backdrop zindex
                    const backdropElement = document.querySelector('.modal-backdrop');
                    if (backdropElement) {
                        (backdropElement as HTMLElement).style.zIndex = '';
                    }
                });
            }
        });
    }

    close() {
        if (this.modal) {
            this.modal.hide();
        }
    }
}
